export default [
  {
    path: '/orderConfirm/:from?',
    name: 'orderConfirm',
    component: () =>
      import(
        /* webpackChunkName: "confirmOrder" */ '@/views/spc/orderConfirm/orderConfirm.vue'
      )
  },
  {
    path: '/payFail',
    name: 'payFail',
    component: () =>
      import(
        /* webpackChunkName: "thankYouPage" */ '@/views/spc/thankYouPage/payFail/PayFail.vue'
      )
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: () =>
      import(
        /* webpackChunkName: "thankYouPage" */ '@/views/spc/thankYouPage/paySuccess/PaySuccess.vue'
      )
  },
  {
    path: '/payAbnormal',
    name: 'payAbnormal',
    component: () =>
      import(
        /* webpackChunkName: "thankYouPage" */ '@/views/spc/thankYouPage/payAbnormal/PayAbnormal.vue'
      )
  },
  {
    path: '/fillAddress/:type?',
    name: 'fillAddress',
    component: () =>
      import(
        /* webpackChunkName: "fillAddress" */ '@/views/address/fillAddress/FillAddress.vue'
      )
  },
  {
    path: '/fillKYC/:fromType/:type/:orderId?',
    name: 'fillKYC',
    component: () =>
      import(
        /* webpackChunkName: "fillKYC" */ '@/views/kyc/fillKYC/FillKYC.vue'
      )
  },
  {
    path: '/addressList',
    name: 'addressList',
    component: () =>
      import(
        /* webpackChunkName: "addressList" */ '@/views/address/addressList/AddressList.vue'
      )
  },
  {
    path: '/kycList',
    name: 'kycList',
    component: () =>
      import(
        /* webpackChunkName: "kycList" */ '@/views/kyc/KYCList/KYCList.vue'
      )
  }
];
